import { render, staticRenderFns } from "./TabRelationAddresses.vue?vue&type=template&id=0338a920"
import script from "./TabRelationAddresses.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationAddresses.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports